import '../../styles/fallback.css';

export default function Fallback (){
    return (
    <div className='fallback-loader'>
        <div>
        <h1>Venkat</h1>
        </div>
    </div>);
}